module.exports = __webpack_public_path__ + "img/wellwellwell2.d55b992f.png";